import { defaultEthereumProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/ethereum/default-constants';

export const SUSHI_SWAP_ETHEREUM_CONTRACT_ADDRESS = '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F';

export const SUSHI_SWAP_ETHEREUM_PROVIDER_CONFIGURATION = defaultEthereumProviderConfiguration;
